import React, { useEffect } from "react";

const VerticalAdBar = () => {
  useEffect(() => {
    if (window.adsbygoogle) {
      window.adsbygoogle.push({});
    }
  }, []);

  return (
    <div className="w-32 sm:w-40 h-full">
      <ins
        className="adsbygoogle block"
        style={{ width: '160px', height: '600px' }}
        data-ad-client="ca-pub-xxxxxxxxxxxxxxxx"
        data-ad-slot="1234567890"
        data-ad-format="vertical"
      ></ins>
    </div>
  );
};

export default VerticalAdBar;
